export const FormatSettlementPeriods = (settlementPeriods: number[]) => {
    let spArray = [...settlementPeriods]
    spArray.sort()
    var response = ""
    if (spArray.length === 1) { response = spArray[0].toString() }
    if (spArray.length > 1) {
        for (var i = 0; i < spArray.length - 1; i++) {
            response += spArray[i].toString()
            response += ", "
        }
        response = response.substring(0, response.length - 2)
        response += (" & " + spArray[spArray.length - 1])
    }
    return response
}